import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Link from '@src/components/link';
import styles from './index.less';
import Store from './store';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
const lang = getLanguageByPath();

/**
 * EighthPage
 * @param store {EighthPageStore}
 * @returns {JSX.Element}
 * @constructor
 */
const EighthPage = ({ store }) => {
  store.use();

  return (
    <div className={cx(styles.eighthPageRoot)}>
      <div className={styles.title} style={{ backgroundImage: `url(${require(`./images/${lang}/title.png`)})` }} />
      <div className={styles.method}>
        <div className={styles.methodItem}>
          <Link className={styles.customerService} href={store.customerServiceLink} target="_blank">
            <div className={styles.content} style={{ backgroundImage: `url(${require(`./images/${lang}/service.png`)})` }} />
          </Link>
        </div>
        <div className={styles.methodItem}>
          <Link className={styles.email} onClick={store.copyEmail}>
            <div className={styles.content} style={{ backgroundImage: `url(${require(`./images/${lang}/email.png`)})` }} />
          </Link>
        </div>
      </div>
      <div className={styles.followUs}>
        <div className={styles.title} style={{ backgroundImage: `url(${require(`./images/${lang}/text-follow-us.png`)})` }} />
        <div className={styles.content}>
          {store.itemList.map(item => (
            <Link key={item.name} className={styles.platform} href={item.link} onClick={item.onClick} target="_blank">
              <img className={styles.normal} src={item.img} alt={item.name} />
              <img className={styles.active} src={item.activeImg} alt={item.name} />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default wrapStore(EighthPage, Store);
